import React from 'react';
import { AuthWrapper } from '@/features/core/auth/screens/AuthWrapper';
import Img1 from '@/assets/images/img-1.png';
import Img2 from '@/assets/images/img-2.png';

export const AboutContainer: React.FC = () => (
  <AuthWrapper isHomepage={false}>
    <div className="w-full bg-white font-dmsans min-h-[70vh]">
      <div className="container mx-auto px-4 pt-10 pb-20 max-w-5xl">
        {/* Header */}
        <div className="mb-12 border-b border-gray-100 pb-6 text-center md:text-left">
          <span className="text-sm font-semibold tracking-wider text-primary-500 uppercase">
            Sobre a Banca do Ingresso
          </span>
          <h1 className="text-primary-500 text-3xl md:text-4xl font-bold mt-1">Quem somos</h1>
        </div>

        {/* Hero Highlight Quote */}
        <div className="bg-gradient-to-r from-primary-500/10 via-primary-500/5 to-transparent border-l-4 border-primary-500 rounded-r-2xl p-8 mb-16 shadow-sm">
          <p className="text-gray-900 text-xl md:text-2xl font-bold leading-relaxed">
            &ldquo;Queremos revolucionar o universo de compra online de ingressos por um modo mais
            simples e descomplicado.&rdquo;
          </p>
        </div>

        {/* Content Section 1 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="order-2 lg:order-1 space-y-4">
            <h2 className="text-2xl font-bold text-gray-900">
              Sua diversão é o nosso grande evento
            </h2>
            <p className="text-gray-600 text-base leading-relaxed">
              A <strong className="text-primary-500">Banca do Ingresso</strong> é uma empresa criada
              em 2009 com o objetivo de proporcionar a seus clientes todo{' '}
              <strong>conforto, agilidade e confiabilidade</strong> do princípio ao fim de cada
              evento.
            </p>
            <p className="text-gray-600 text-base leading-relaxed">
              Trabalhamos continuamente para oferecer a melhor tecnologia na gestão e venda de
              ingressos, tornando cada experiência inesquecível. O nosso maior evento é ver você
              aproveitar a vida.
            </p>
          </div>
          <div className="order-1 lg:order-2 overflow-hidden rounded-2xl shadow-md border border-gray-100">
            <img
              src={Img2}
              alt="Quem somos - Banca do Ingresso"
              className="w-full h-[320px] object-cover hover:scale-105 transition-transform duration-300"
            />
          </div>
        </div>

        {/* Content Section 2 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="overflow-hidden rounded-2xl shadow-md border border-gray-100">
            <img
              src={Img1}
              alt="Experiência Banca do Ingresso"
              className="w-full h-[320px] object-cover hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-gray-900">Inovação e Segurança</h2>
            <p className="text-gray-600 text-base leading-relaxed">
              Oferecemos uma plataforma robusta e segura para a compra de ingressos para os
              principais shows, festivais e eventos do país.
            </p>
          </div>
        </div>
      </div>
    </div>
  </AuthWrapper>
);
